// extracted by mini-css-extract-plugin
export default {"grid":"grid__SearchPage__FUCPL"};